import React, { useState } from "react";
import * as Yup from "yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle, Save, Trash2 } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  FormProvider,
  useForm,
  useFieldArray,
  Controller,
} from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, array, string, number } from "yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { useInsertCPFContributionRateMutation } from "AppQuries/master/CpfContributionRate/cpf-contribution-rate";
import { useCPFContributionQuery } from "AppQuries/master/CpfContribution/contributions";
import { cpfContributionRateValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
import Select from "react-select";

const AddCPFContributionRate = () => {
  const userData = useSelector(loggedInUser);
  const { data } = useCPFContributionQuery();
  const navigate = useNavigate();
  const {
    mutate: addCpfContribution,
    isError,
    error,
  } = useInsertCPFContributionRateMutation();
  console.log(data?.data);
  const contributionOptions =
    data?.data
      ?.filter((r) => r.isActive)
      .map((r) => ({
        id: r.contributionCode,
        label: r.contributionName,
        value: r.contributionCode,
      })) || [];

  const methods = useForm({
    defaultValues: { cpfContributionRates: [] },
    resolver: yupResolver(cpfContributionRateValidation),
  });

  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = methods;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "cpfContributionRates",
  });

  console.log(errors);

  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const onSubmit = (payload) => {
    const cpfContributionRates = payload?.cpfContributionRates || [];
    addCpfContribution(cpfContributionRates, {
      onSuccess: (data) => {
        console.log(data)
        if (data?.[0]?.response === true) {
          setMessage("CPF Contribution Rate Added Successfully.");
          setShowSuccessToast(true);
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.cpfContributionRates}`);
          }, 1000);
        } else {
          setMessage(data?.[0]?.errorMessage || "Something went wrong.");
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        setMessage(error.message || "Something went wrong.");
        setShowErrorToast(true);
      },
    });
  };

  const addRowHandler = () => {
    append({
      companyCode: userData.companyCode,
      code: 0,
      contributionCode: "",
      rangeFrom: "",
      rangeTo: "",
      amount: "",
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
  };

  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <ToastNotification
        showSuccessToast={showSuccessToast}
        showErrorToast={showErrorToast}
        message={message}
      />
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <h4>Add CPF Contribution Rates</h4>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Save CPF Contribution Rates</Tooltip>}
                >
                  <button type="submit" className="btn btn-added">
                    <Save className="me-2" /> Save
                  </button>
                </OverlayTrigger>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header d-flex justify-content-between mb-3">
                      <h4 className="card-title">CPF Contribution Rates</h4>
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={addRowHandler}
                      >
                        <PlusCircle className="me-2" /> Add Row
                      </button>
                    </div>
                    <div className="card-body">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th style={{ width: "100px", textAlign: "center" }}>
                              Actions
                            </th>
                            <th>Contribution Code</th>
                            <th>Range From</th>
                            <th>Range To</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fields.map((field, index) => (
                            <tr key={field.id}>
                              <td
                                style={{ textAlign: "center" }}
                                className="action-table-data"
                              >
                                <div className="edit-delete-action">
                                  <div className="input-block add-lists"></div>
                                  <Link
                                    type="button"
                                    className="btn btn-sm me-2 p-2"
                                    onClick={() => remove(index)}
                                  >
                                    <Trash2 />
                                  </Link>
                                </div>
                              </td>
                              <td>
                                <Controller
                                  name={`cpfContributionRates[${index}].contributionCode`}
                                  control={control}
                                  defaultValue={watch(
                                    `cpfContributionRates[${index}].contributionCode`
                                  )}
                                  render={({ field }) => (
                                    <Select
                                      {...field}
                                      options={contributionOptions}
                                      className={` ${
                                        errors?.cpfContributionRates?.[index]
                                          ?.contributionCode
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      value={contributionOptions.find(
                                        (option) => option.value === field.value
                                      )}
                                      onChange={(selectedOption) => {
                                        field.onChange(
                                          selectedOption
                                            ? selectedOption.value
                                            : ""
                                        );
                                      }}
                                    />
                                  )}
                                />
                                {errors?.cpfContributionRates?.[index]
                                  ?.contributionCode && (
                                  <div className="invalid-feedback">
                                    {
                                      errors.cpfContributionRates[index]
                                        .contributionCode.message
                                    }
                                  </div>
                                )}
                              </td>

                              <td>
                                <Controller
                                  name={`cpfContributionRates[${index}].rangeFrom`}
                                  control={control}
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      type="text"
                                      placeholder="Range From"
                                      className={`form-control ${
                                        errors?.cpfContributionRates?.[index]
                                          ?.rangeFrom
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                    />
                                  )}
                                />
                                {errors?.cpfContributionRates?.[index]
                                  ?.rangeFrom && (
                                  <div className="invalid-feedback">
                                    {
                                      errors.cpfContributionRates[index]
                                        .rangeFrom.message
                                    }
                                  </div>
                                )}
                              </td>

                              <td>
                                <Controller
                                  name={`cpfContributionRates[${index}].rangeTo`}
                                  control={control}
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      type="text"
                                      placeholder="Range To"
                                      className={`form-control ${
                                        errors?.cpfContributionRates?.[index]
                                          ?.rangeTo
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                    />
                                  )}
                                />
                                {errors?.cpfContributionRates?.[index]
                                  ?.rangeTo && (
                                  <div className="invalid-feedback">
                                    {
                                      errors.cpfContributionRates[index].rangeTo
                                        .message
                                    }
                                  </div>
                                )}
                              </td>
                              <td>
                                <Controller
                                  name={`cpfContributionRates[${index}].amount`}
                                  control={control}
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      type="text"
                                      placeholder="Amount"
                                      className={`form-control ${
                                        errors?.cpfContributionRates?.[index]
                                          ?.amount
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                    />
                                  )}
                                />
                                {errors?.cpfContributionRates?.[index]
                                  ?.amount && (
                                  <div className="invalid-feedback">
                                    {
                                      errors.cpfContributionRates[index].amount
                                        .message
                                    }
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddCPFContributionRate;
